import React, { useState } from "react"
import PropTypes from "prop-types"

const Input = ({ label, name, ...rest }) => {
  // state
  const [isFocused, setIsFocused] = useState(false);
  // UI
  return (
    <div className="input-block">
      <label htmlFor={name} className={isFocused ? 'selected' : 'regular'}>
        {label}
      </label>
      <input 
        type="text" 
        id={name} 
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...rest} 
      />
    </div>
  )
}

Input.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default Input
